import { useT } from '~/i18n';
import type { PlanState } from '../lib/plan';
import { usePlanCta } from '../lib/planCta';

/**
 * «Lo que se te fue esta semana». Conteos del servidor (`missed_week`), sin
 * modelo: vacantes que llegaron para su perfil, a cuántas postuló y cuántos
 * empleadores contestaron. Las respuestas se cuentan, no se clasifican:
 * clasificarlas es lo que compra el plan.
 *
 * Habla de lo que hace la herramienta, nunca de resultados. El servidor la
 * manda en null con plan activo o con el interruptor apagado.
 */
export interface MissedWeek {
  new_postings: number;
  applied: number;
  replies: number;
}

interface Props {
  missed: MissedWeek;
  plan: PlanState;
  /** Abre la oferta (surface 'missed_week'). */
  onPlan: () => void;
}

export default function MissedWeekCard({ missed, plan, onPlan }: Props) {
  const t = useT('workspace').dashboard.missedWeek;
  const cta = usePlanCta(plan);

  return (
    <div className="card rise">
      <div className="card-body space-y-2">
        <span className="brand-label">{t.label}</span>
        <p className="text-sm font-semibold">{t.title(missed.new_postings, missed.applied)}</p>
        <ul className="text-xs list-disc pl-4 space-y-1" style={{ color: 'var(--ink-soft)' }}>
          <li>{t.withPlan}</li>
          {missed.replies > 0 && (
            <li>
              <strong>{t.replies(missed.replies)}</strong> {t.repliesAfter}
            </li>
          )}
        </ul>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <button type="button" className="btn btn-primary btn-sm" onClick={onPlan}>
            {cta.label}
          </button>
          <span className="text-xs hush">{cta.note}</span>
        </div>
      </div>
    </div>
  );
}
